import type { LaserPattern } from "./LaserPattern";
import type { ChargeFireContext, Direction } from "../../charges/Charge";

/**
 * A lightweight "zig-zag" feel using the available cardinal laser API:
 * fire forward, then an alternating side-beam each time the charge is used.
 */
export class LightningZigZagPattern implements LaserPattern {
  private flip = false;

  fire(ctx: ChargeFireContext): void {
    const shoot = ctx.shootLaser;
    if (!shoot) return;

    shoot(ctx.direction);
    shoot(this.flip ? relativeLeft(ctx.direction) : relativeRight(ctx.direction));
    this.flip = !this.flip;
  }
}

function relativeLeft(dir: Direction): Direction {
  switch (dir) {
    case "up":
      return "left";
    case "down":
      return "right";
    case "left":
      return "down";
    case "right":
      return "up";
  }
}

function relativeRight(dir: Direction): Direction {
  switch (dir) {
    case "up":
      return "right";
    case "down":
      return "left";
    case "left":
      return "up";
    case "right":
      return "down";
  }
}

export const lightningZigZagPattern = new LightningZigZagPattern();
